import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TabNavigation, type TabConfig } from '../../components/TabNavigation';
import { DailyTaskTemplates } from './components/DailyTaskTemplates';
import { DailyTaskUserTasks } from './components/DailyTaskUserTasks';

type DailyTasksTabType = 'templates' | 'user';

const tabs: TabConfig<DailyTasksTabType>[] = [
  { id: 'templates', label: 'Daily Task Templates', icon: '🗒️' },
  { id: 'user', label: 'User Tasks', icon: '👤' },
];

const isValidTab = (tab: string | null): tab is DailyTasksTabType => {
  return tab === 'templates' || tab === 'user';
};

export const DailyTasks = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<DailyTasksTabType>('templates');

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (isValidTab(tabParam)) {
      setActiveTab(tabParam);
    } else {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set('tab', 'templates');
          return next;
        },
        { replace: true },
      );
    }
  }, [searchParams, setSearchParams]);

  const handleTabChange = (tab: DailyTasksTabType) => {
    setActiveTab(tab);
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set('tab', tab);
        return next;
      },
      { replace: true },
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 py-6">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Daily Tasks</h1>

        <TabNavigation tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />

        {activeTab === 'templates' && <DailyTaskTemplates />}
        {activeTab === 'user' && <DailyTaskUserTasks />}
      </div>
    </div>
  );
};
